/* eslint-disable */

import React, { useState, useLayoutEffect, useEffect } from 'react';
import { useSpring, config, animated } from 'react-spring';
import hexToRgba from 'hex-to-rgba';
import * as cn from 'classnames';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import Container from '../components/Container';
import Card from '../components/Card';
import Icon from '../components/Icon';

import './Portfolio.scss';

const RepoCard = ({ idx, repo, skills }) => {
  const [fetchedImgUrl, setFetchedImgUrl] = useState('');
  const [isBtnHover, setIsBtnHover] = useState(false);

  useEffect(() => {
    const fetchImg = async () => {
      const url = await fetch(repo.img).then((res) => res.url);
      setFetchedImgUrl(url);
    };
    fetchImg();
  }, []);

  const slideStyles = useSpring({
    config: { ...config.wobbly },
    from: { x: -200 },
    to: { x: 0, scale: isBtnHover ? 1.05 : 1 },
    delay: 30,
  });

  const tags = repo.tags.map((t) => _.find(skills, { name: t }));

  const Content = () => (
    <div className="col-12 col-md-6">
      <div
        className={`my-md-5 ${idx % 2 === 0 ? 'text-md-end' : 'text-md-start'}`}
      >
        <div className="mt-2">
          <div className="lead">{repo.name}</div>
          <div className="text-gray">{repo.description}</div>
        </div>
        <div className="tags mt-3">
          {tags.map((t, idx) => (
            <span
              key={idx}
              className="badge rounded-pill shine m-1"
              style={{
                color: t.color,
                background: hexToRgba(t.color, 0.1),
                border: `1px solid ${hexToRgba(t.color, 0.3)}`,
              }}
            >
              <Icon type={t.type} icon={t.icon} className="colored" />
              &nbsp;{t.name}
            </span>
          ))}
        </div>
        {repo.url && (
          <animated.a
            rel="noreferrer"
            target="_blank"
            href={repo.url}
            className="btn btn-outline-light mt-4 mt-md-5 px-4"
            onMouseEnter={() => setIsBtnHover(true)}
            onMouseLeave={() => setIsBtnHover(false)}
            style={{
              fontWeight: 'normal',
              letterSpacing: '0.1em',
              ...slideStyles,
            }}
          >
            View
          </animated.a>
        )}
      </div>
    </div>
  );

  const Thumbnail = () => (
    <div className="col-12 col-md-6">
      <div className="my-md-5">
        <Card
          className="card-placeholder gradient-border mx-auto shadow-lg"
          style={{ maxWidth: '400px', aspectRatio: '16/9' }}
        >
          <div
            className={`image-contaner shine ${
              !fetchedImgUrl ? 'skeleton-loading' : ''
            }`}
          >
            {!!fetchedImgUrl && (
              <img
                alt={repo.name}
                src={fetchedImgUrl}
                style={{ width: '100%', minHeight: '100%' }}
              />
            )}
          </div>
        </Card>
      </div>
    </div>
  );

  return (
    <div
      className={cn('row mb-5 mb-md-0', {
        'flex-md-row-reverse': idx % 2 === 0,
      })}
    >
      <Thumbnail />
      <Content />
    </div>
  );
};

function Portfolio({ id, data, ...props }) {
  const [repos, setRepos] = useState([]);

  useLayoutEffect(() => {
    fetch('./repos.json')
      .then((_) => _.json())
      .then(setRepos);
  }, []);

  return (
    <section id={`${id}-section`} {...props}>
      <Container
        id={id}
        title="MY PROJECTS"
        titleClassName="underline fw-bold"
        description="Here are a few projects I've worked."
        headerClassName="mb-5"
        moreAction={true}
        nthChildShow={2}
      >
        <div className="col-12">
          {repos.map((repo, idx) => (
            <RepoCard key={idx} idx={idx} repo={repo} skills={data} />
          ))}
        </div>
      </Container>
    </section>
  );
}

Portfolio.defaultProps = {
  id: 'portfolio',
};

Portfolio.propTypes = {
  id: PropTypes.string,
};

export default React.memo(Portfolio, (prev, next) => true);
